import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { selectDraft, selectFieldErrors } from '@/store/selectors/createSix';
import { setDraftField } from '@/store/slices/createSix/createSixSlice';

interface UseStepSixInfoState {
  nameValue: string;
  descriptionValue: string;
  nameError: string | undefined;
  descriptionError: string | undefined;
}

interface UseStepSixInfoHandlers {
  handleNameChange: (nextValue: string) => void;
  handleDescriptionChange: (nextValue: string) => void;
}

interface UseStepSixInfoReturn {
  state: UseStepSixInfoState;
  handlers: UseStepSixInfoHandlers;
}

export function useStepSixInfo(): UseStepSixInfoReturn {
  const dispatch = useAppDispatch();
  const draft = useAppSelector(selectDraft);
  const fieldErrors = useAppSelector(selectFieldErrors);

  const nameValue = typeof draft.name === 'string' ? draft.name : '';
  const descriptionValue = typeof draft.description === 'string' ? draft.description : '';
  const nameError = fieldErrors.name;
  const descriptionError = fieldErrors.description;

  const handleNameChange = useCallback(
    (nextValue: string): void => {
      dispatch(setDraftField({ key: 'name', value: nextValue }));
    },
    [dispatch]
  );

  const handleDescriptionChange = useCallback(
    (nextValue: string): void => {
      dispatch(setDraftField({ key: 'description', value: nextValue }));
    },
    [dispatch]
  );

  return {
    state: {
      nameValue,
      descriptionValue,
      nameError,
      descriptionError,
    },
    handlers: {
      handleNameChange,
      handleDescriptionChange,
    },
  };
}
